import { apiSlice } from "../../app/api/apiSlice";

export const getUserEmailByDocumentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getUserEmailByDocument: builder.mutation({
			query: ({ documentId }) => ({
				url: `/api/v1/loan/get_user_email_by_document/${encodeURIComponent(
					documentId ?? ""
				)}/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetUserEmailByDocumentMutation } =
	getUserEmailByDocumentApiSlice;
